/**
 * Set a regular expression as a pattern on an input element.
 *
 * **Patterns do not accept flags/modifiers.** Global, ignoreCase and multiLine will be removed.
 *
 * @example <caption>Basic usage with an imported regex from our pattern matching utilities.</caption>
 * import {setInputPattern} from './utils/dom/setInputPattern';
 * import {emailRegex} from "./utils/patternMatching/email";
 *
 * const emailInput = document.querySelector("form input.email");
 * setInputPattern(emailInput, emailRegex());
 *
 * @example <caption>Set a pattern for only accepting names with one capital letter followed by one or more lowercase letters.</caption>
 * const nameInput = document.querySelector("form input.name");
 * setInputPattern(nameInput, /^[A-ZÆØÅ][a-zæøå]+$/);
 */

/**
 * Set a regex as a pattern on an input element.
 *
 * @param {HTMLInputElement|Element} inputElement - Input element to set pattern on.
 * @param {RegExp} regex - Regular expression. **Notice** that flags will be removed (global, ignoreCase, multiLine).
 */
export function setInputPattern(inputElement: HTMLElement, regex: RegExp) {
	if (!regex) {
		return;
	}

	const pattern = regex.toString().match(/\/(?:\n|.)*\//)?.[0].replace(/^\/|\/$/g, "");

	if (pattern) {
		inputElement.setAttribute("pattern", pattern);
	}
}
